import React, { useState } from "react"
import { Link } from "react-scroll"
import { FiMenu } from "react-icons/fi"
import { MdClose } from "react-icons/md"
import {
  FaTwitter,
  FaLinkedinIn,
  FaGithub,
  FaWhatsapp,
} from "react-icons/fa"
import { navLinksdata } from "../../constants"
import { motion } from "framer-motion"

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false)

  return (
    <div className="w-full h-24 sticky top-0 z-50 bg-bodyColor mx-auto flex justify-between items-center font-titleFont border-b border-b-gray-600 px-1">
      
      {/* ===== Top Left Logo (Animated, NOT clickable) ===== */}
      <div className="flex items-center">
        <motion.img
          src="/TopLeftLogo.png"
          alt="logo"
          className="w-28 h-24 object-contain cursor-default"
          whileHover={{
            scale: 1.05,
            rotate: -1,
          }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: "spring", stiffness: 300 }}
        />
      </div>

      {/* ===== Desktop Navigation ===== */}
      <div>
        <ul className="hidden mdl:inline-flex items-center gap-6 lg:gap-10">
          {navLinksdata.map(({ _id, title, link }) => (
            <li
              key={_id}
              className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
            >
              <Link
                activeClass="active"
                to={link}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {title}
              </Link>
            </li>
          ))}
        </ul>

        {/* ===== Mobile Menu Button ===== */}
        <span
          onClick={() => setShowMenu(true)}
          className="text-xl mdl:hidden bg-black w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer"
        >
          <FiMenu />
        </span>

        {/* ===== Mobile Menu ===== */}
        {showMenu && (
          <div className="w-[80%] h-screen absolute top-0 left-0 bg-gray-900 p-4 overflow-y-auto">
            <div className="flex flex-col gap-6 relative">

              {/* ===== Mobile Logo (Animated, NOT clickable) ===== */}
              <div className="flex justify-start -ml-4">
                <motion.img
                  src="/TopLeftLogo.png"
                  alt="logo"
                  className="w-20 h-16 object-contain cursor-default"
                  whileHover={{
                    scale: 1.05,
                    rotate: -1,
                  }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: "spring", stiffness: 300 }}
                />
              </div>

              {/* ===== Mobile Nav Links ===== */}
              <ul className="flex flex-col gap-3 mt-2">
                {navLinksdata.map((item) => (
                  <li
                    key={item._id}
                    className="text-base text-gray-400 hover:text-designColor duration-300"
                  >
                    <Link
                      onClick={() => setShowMenu(false)}
                      activeClass="active"
                      to={item.link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>

              {/* ===== Mobile Social Icons ===== */}
              <div className="mt-5">
                <h2 className="text-xs uppercase font-titleFont text-gray-500 tracking-widest mb-4">
                  Find me in
                </h2>

                <div className="flex gap-3 mt-4">
                  {[
                    {
                      icon: <FaLinkedinIn />,
                      link: "https://www.linkedin.com/in/thebideveloper/",
                    },
                    {
                      icon: <FaWhatsapp />,
                      link: "https://wa.me/918237234351",
                    },
                    {
                      icon: <FaGithub />,
                      link: "https://github.com/TheBIDeveloper",
                    },
                    {
                      icon: <FaTwitter />,
                      link: "https://x.com/__TheDeveloper_",
                    },
                  ].map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      target="_blank"
                      rel="noreferrer"
                      className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:text-designColor transition-all duration-300"
                    >
                      <span className="text-sm">
                        {item.icon}
                      </span>
                    </a>
                  ))}
                </div>
              </div>

              {/* ===== Close Button ===== */}
              <span
                onClick={() => setShowMenu(false)}
                className="absolute top-2 right-2 text-gray-400 hover:text-designColor text-2xl cursor-pointer"
              >
                <MdClose />
              </span>

            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Navbar
